import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import { formatToDecimal } from '../../../controls/conversions';
import { formatToFractional } from '../../../controls/conversions';

const WindowHeight = ({ value, onChange, id = 'WindowHeight', label = 'Window Height', minW = 20, maxW = 400,
                       doorSizeValue = null, doorHeightValue = null, passSelectedDoor,
                       disabled = false
 }) => {
    const [selectedWindowHeight, setSelectedWindowHeight] = useState(value || "80\"");
    const [WindowHeightError, setWindowHeightError] = useState("");

     useEffect(() => {
        setSelectedWindowHeight(value || "1");
    }, [value]);

    const calcWidth = (doorType, doorSize) => {
        if (doorType === 1) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) + 1).toString() + ' 1/2"';
        }
        if ([2, 3].includes(doorType)) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) + 17).toString() + '"';
        }
        if (doorType === 4) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) + 32).toString() + ' 1/2"';
        }
        if (doorType === 5) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) * 2 + 2).toString() + '"';
        }
        if ([6, 7].includes(doorType)) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) * 2 + 17).toString() + ' 1/2"';
        }
        if (doorType === 8) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) * 2 + 2*17 - 1).toString() + '"';
        }
        return 0;
     }
     
    useEffect(() => {
        if (passSelectedDoor) {
            if (passSelectedDoor.id > 4) {
                validateWindowHeight(selectedWindowHeight,minW, maxW);

            }
            else {

                validateWindowHeight(selectedWindowHeight, minW, maxW);

            }
            //alert(selectedWindowHeight);
            //validateWindowHeight(selectedWindowHeight);
        }
        if (!doorSizeValue) {
            const element = document.getElementById("DoorSize");
            if (element) { 
                doorSizeValue = element.value;
            }
        }
        if (doorHeightValue) {}
        if (passSelectedDoor && doorSizeValue) {
            //alert(JSON.stringify(passSelectedDoor, null, 2));
            const w = calcWidth(passSelectedDoor.id, doorSizeValue);
            setSelectedWindowHeight(w);
            validateWindowHeight(w);
            onChange(w);
        }
      }, [doorSizeValue, doorHeightValue, passSelectedDoor, value]); // Trigger effect whenever doorSizeValue changes

    const handleWindowHeightChange = (e) => {
        //setSelectedWindowHeight(e.target.value);
        validateWindowHeight(e.target.value);
        // Don't call onChange here - only update on blur to avoid intermediate render issues
    };

    const validateWindowHeight = (value, mmin = null, mmax = null) => {
        
        if (mmin === null) mmin = minW;
        if (mmax === null) mmax = maxW;
        const numericValue = formatToDecimal(value);
        setSelectedWindowHeight(value);
        if (numericValue && (numericValue < mmin || numericValue > mmax)) {
            setWindowHeightError(`must be between ${mmin} and ${mmax}`);
        } else {
            setWindowHeightError("");
        }
    };


        
    const handleFocus = (e) => {
      let decimalValue = formatToDecimal(e.target.value);
      if (decimalValue === 0) decimalValue = "";
      setSelectedWindowHeight(decimalValue);
    };

    const handleBlur = (e) => {
      const fractionalValue = formatToFractional(e.target.value);
      setSelectedWindowHeight(fractionalValue);
      onChange(fractionalValue);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="WindowHeight">{label}</label>
            <input
                disabled={disabled}
                id={id}
                value={selectedWindowHeight}
                onChange={handleWindowHeightChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
            >
            </input>
            {WindowHeightError && <p className="error">{WindowHeightError}</p>}
        </div>
    );
};

export default WindowHeight;